// extracted by mini-css-extract-plugin
module.exports = {"mainRow":"Promotions_mainRow__J3Fkm","mainCol":"Promotions_mainCol__3Bg5d"};